/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import { Typography } from '@mui/material';
import { useNotSavedOrderPrices } from 'pages/Week/components/WeekDayTotalLabel/useNotSavedOrderPrices';
import WarningLabel from 'pages/Week/components/WeekDayTotalLabel/WarningLabel';
import { useGetOrderApi } from 'pages/Week/hooks/useGetOrderApi';
import { TXT_FORMATTED_PRICE, TXT_LOADING } from 'translations';
import { formatCurrency } from 'utils/string/formatCurrency';
import { Props } from './types';

const WeekDayTotalLabel: FC<Props> = ({ dayDate }) => {
  const { t } = useTranslation();
  const { isLoading, isError, totalAmount, order } = useGetOrderApi(dayDate);
  const dateOrderSum = useNotSavedOrderPrices();

  if (isLoading) {
    return <Typography variant="h3">{t(TXT_LOADING)}</Typography>;
  }

  if (isError) {
    return (
      <Typography variant="h3" display="flex" justifyContent="start">
        {t(TXT_FORMATTED_PRICE, {
          price: formatCurrency(dateOrderSum[dayDate] || 0),
        })}
        <WarningLabel dayDate={dayDate} />
      </Typography>
    );
  }

  if (order) {
    return (
      <Typography variant="h3" display="flex" justifyContent="start">
        {formatCurrency(totalAmount)}
        <CheckIcon color="success" fontSize="small" />
      </Typography>
    );
  }

  return <Typography variant="h3">{formatCurrency(totalAmount)}</Typography>;
};

export default WeekDayTotalLabel;
